<template>
	<div class="serviceDetail" v-if="data">
		<span class="dGoBack" @click="$router.go(-1)"></span>
		<h3>{{ data.articleTitle }}</h3>
		<p class="dTime">{{ data.createTime }}</p>
		<div class="dImgBox"><img class="dImg" v-lazy="'http://www.zhilianyueju.com/'+data.articleImgName"/></div>
		<div class="dImgBox"><img class="dImg" v-if="data.articleImgName2!=null" v-lazy="'http://www.zhilianyueju.com/'+data.articleImgName2"/></div>
		<div class="dImgBox"><img class="dImg" v-if="data.articleImgName3!=null" v-lazy="'http://www.zhilianyueju.com/'+data.articleImgName3"/></div>
		<div class="dImgBox"><img class="dImg" v-if="data.articleImgName4!=null" v-lazy="'http://www.zhilianyueju.com/'+data.articleImgName4"/></div>
		<div class="dImgBox"><img class="dImg" v-if="data.articleImgName5!=null" v-lazy="'http://www.zhilianyueju.com/'+data.articleImgName5"/></div>
		<div class="dCon">
			<div class="dCon2" v-html="data.articleContent"></div>
		</div>
	</div>
</template>
<script>
import Api from '../../api/api';
import {Indicator} from 'mint-ui';
export default {
	name: 'detail',
	data() {
		return {
			data: null
		};
	},
	mounted() {
		this.getDetail();
	},
	methods: {
		getDetail() {
			let id = this.$route.params.id;
			Indicator.open({
			    spinnerType: 'fading-circle'
			});
			Api.articleGet(id, msg => {
				if (msg.code == 200) {
					this.data = msg.body;
					Indicator.close();
				}else{
					Indicator.close();
				}
			});
		}
	}
};
</script>
<style scoped>
@import url('./style/service.css');

.serviceDetail {
	min-height: 100vh;
	background: #fff;
	padding: 0 15px;
	overflow: hidden;
}
.dCon{
	width: 100%;
	overflow: hidden;
}
.dCon2{
	white-space:pre-wrap;
	word-break:break-all;
	font-size: 15px;
	text-indent: 30px;
}
img[lazy='loading'] {
	height: 48px;
	width: 48px;
	background-color: #EEEEEE;
}
img[lazy='loaded'] {
	min-height: 48px;
	min-width: 48px;
	background-color: #EEEEEE;
}
img[lazy='error'] {
	background: url(../../assets/images/fail.png) no-repeat center;
}
</style>



// WEBPACK FOOTER //
// src/components/service/serviceDetail.vue